import { useEffect, useRef } from 'react';
import { useAuth } from '../../auth/context/AuthContext';
import { notificationsApi } from '../api/notifications.api';

// Stable per-browser device token (persisted so we send the same one each time).
const DEVICE_KEY = 'cc_device_token';
const getDeviceToken = () => {
  try {
    let t = localStorage.getItem(DEVICE_KEY);
    if (!t) {
      t = `web-${Math.abs(Date.now() ^ (performance.now() * 1000 | 0)).toString(36)}-${(navigator.userAgent || '').length}`;
      localStorage.setItem(DEVICE_KEY, t);
    }
    return t;
  } catch {
    return 'web-anonymous';
  }
};

// Registers this browser as a notification device once the user is authenticated.
// Renders nothing. Failures are swallowed (best-effort, non-blocking).
const NotificationsInit = () => {
  const { isAuthenticated } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || done.current) return;
    done.current = true;
    notificationsApi
      .addOrUpdateDevice({ deviceToken: getDeviceToken(), deviceType: 'web' })
      .catch(() => { /* best-effort; ignore */ });
  }, [isAuthenticated]);

  return null;
};

export default NotificationsInit;
